import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Input,
  Form,
  Button,
  Card,
  Typography,
  Image,
  notification,
  Layout,
  Row,
  Col,
} from "antd";
import "../Screens/otp.css";
import { useDispatch, useSelector } from "react-redux";
import actions from "../redux/Otp/actions";
import resendOTPActions from "../redux/Login/actions";
import config from "../Services/apiEndPoints";
import { isEmpty } from "lodash";
import StyledButton from "../Utils/styledButton";
import BackgroundImage from "../Utils/styledBackgroundImage";

const { Title, Text } = Typography;
const { Header } = Layout;

export default function OTPVerication() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const typeOfUser =
    localStorage.getItem("typeOfUser") || sessionStorage.getItem("typeOfUser");
  const {
    successMessage: resendOTPSuccMsg,
    errorMessage: resendOTPErrMsg,
    actionType: resendActType,
  } = useSelector((state) => state.logIn);
  const { successMessage, errorMessage, actionType, donorDetails } =
    useSelector((state) => state.otp);

  const loginType = localStorage.getItem("loginType");

  const [timer, setTimer] = useState(40); // Set timer for 60 seconds
  const [isTimerActive, setIsTimerActive] = useState(true);
  const mobileNum = localStorage.getItem("mobileNumber");

  // To manage timer state
  const openNotificationWithIcon = (type, message) => {
    return notification[type]({
      message: message,
    });
  };

  useEffect(() => {
    if (resendActType === resendOTPActions.LOGIN_SUCCESS && resendOTPSuccMsg) {
      notification.success({
        message: resendOTPSuccMsg,
      });
      dispatch(actions.resetActionType());
    } else if (resendActType === actions.LOGIN_ERROR && errorMessage) {
      notification.error({
        message: resendOTPErrMsg,
      });
      dispatch(actions.resetActionType());
    }
  }, [resendActType, resendOTPSuccMsg, resendOTPErrMsg]);

  useEffect(() => {
    if (actionType === actions.OTP_SUCCESS) {
      openNotificationWithIcon("success", successMessage);
      if (loginType === "donor" && !(typeOfUser === "existingUser")) {
        if (!isEmpty(donorDetails)) {
          localStorage.setItem("selected-menu-key", "myDonations");
          // navigate("/dashboard/myDonations");
          console.log("selected-menu-key selected-menu-key")
          navigate("/donorPersonalDetails");
          dispatch(actions.resetActionType());
        } else {
          navigate("/donorPersonalDetails");
          dispatch(actions.resetActionType());
        }
      } else if (loginType === "donor" && typeOfUser === "existingUser") {
        navigate("/dashboard/myDonations");
        dispatch(actions.resetActionType());
      } else if (loginType === "both" && typeOfUser === "existingUser") {
        navigate("/dashboard/myDonations");
      }
    } else if (actionType === actions.RESEND_OTP_SUCCESS) {
      openNotificationWithIcon("success", successMessage);
    } else if (
      actionType === actions.OTP_ERROR ||
      actionType === actions.RESEND_OTP_ERROR
    ) {
      openNotificationWithIcon("error", errorMessage);
    }
  }, [
    actionType,
    successMessage,
    errorMessage,
    loginType,
    typeOfUser,
    navigate,
  ]);

  useEffect(() => {
    // Push the current URL onto history when the OTP screen is shown
    window.history.pushState(null, null, window.location.href);

    const handlePopState = (e) => {
      // Push the same state again to block the back button
      window.history.pushState(null, null, window.location.href);
    };
    // Listen for the popstate event (triggered when the back button is pressed)
    window.addEventListener("popstate", handlePopState);

    return () => {
      // Clean up event listener when the component is unmounted
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    let interval = null;
    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setIsTimerActive(false);
    }
    return () => clearInterval(interval);
  }, [isTimerActive, timer]);

  const handleEditMobile = () => {
    if (typeOfUser === "annadhanam") {
      navigate("/logIn/annadhanam");
    } else if (typeOfUser === "festival") {
      navigate("/logIn/festival");
    } else if (typeOfUser === "existingUser") {
      navigate("/logIn/existingUser");
    }
  };

  const resendOtp = () => {
    setTimer(40);
    setIsTimerActive(true);
    dispatch(
      resendOTPActions.login(config.logIn, { mobileNumber: "+91" + mobileNum })
    );
  };

  const onFinish = (values) => {
    if (otp.some((digit) => digit === "") || otp.length < 6) {
      openNotificationWithIcon("error", "Please enter valid OTP");
      return;
    }
  
    const mobileNumber = localStorage.getItem("mobileNumber");
    const loginType = localStorage.getItem("loginType");
  
    // Convert OTP array to a string
    const otpString = otp.join("");
  
    const payload = {
      mobileNumber: mobileNumber,
      otp: otpString, // Convert array to a string
      type: typeOfUser === "existingUser" ? loginType : typeOfUser,
    };
  
    dispatch(actions.otp(config.otpVerify, payload));
  };
  
    // Handle OTP input change
    const handleChange = (index, e) => {
      const value = e.target.value;
      if (!/^\d*$/.test(value)) return; // Allow only numbers
  
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
  
      // Move focus to the next input field
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    };
      // Handle backspace navigation
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };
  return (
    <div
      style={{
        backgroundColor: "rgba(255, 165, 0, 0.8)",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <Card
        style={{
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          borderRadius: "12px",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <img
          src="/favicon.ico"
          alt="Logo"
          style={{ maxWidth: "100%", height: "auto", marginBottom: "10px" }}
        />

        <Title level={3}>Enter OTP</Title>
        <Text style={{ fontSize: "14px", marginBottom: "20px", display: "block" }}>
          We’ve sent a One Time Password (OTP). Please enter it to complete verification.
        </Text>

        {/* OTP Input Boxes */}
        <Form onFinish={() => onFinish(otp.join(""))}>
          <div style={{ display: "flex", justifyContent: "center", gap: "8px" }}>
            {otp.map((digit, index) => (
              <Input
                key={index}
                id={`otp-input-${index}`}
                value={digit}
                maxLength={1}
                inputMode="numeric"
                pattern="[0-9]"
                style={{
                  width: "40px",
                  height: "40px",
                  textAlign: "center",
                  fontSize: "20px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
                onChange={(e) => handleChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
              />
            ))}
          </div>

          {/* Resend OTP Timer */}
          <div style={{ textAlign: "center", marginTop: "15px" }}>
            {isTimerActive ? (
              <Text>Resend OTP in {timer} seconds</Text>
            ) : (
              <Button type="link" onClick={resendOtp}>
                Resend OTP
              </Button>
            )}
          </div>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button type="primary" htmlType="submit" block>
              Continue
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
